/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.3"
        height="11.23"
        viewBox="0 0 18.3 11.23"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18.3 10.23h-1.67V0h-15v10.21H-.04v1h18.3Zm-2.67 0h-13V1h13Zm-1.13-8.2H3.8v6.79h10.7Zm-1 5.78H4.8V3.03h8.7Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'LaptopComputerIcon';

export default Icon;
